import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import lang from "./i18n/locales";
i18n.use(initReactI18next).init({
  resources: lang,
  // Where we're gonna put translations' files
  lng: "pt-BR", // Set the initial language of the App
});
